import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axios from 'axios';
import Spinner from '../ogComponent/spinner';
import Table from '../ogComponent/table';

export default function StudentDayPunch() {
    const { id } = useParams();
    const [student, setStudent] = useState({});
    const [selectDate, setSelectDate] = useState(dayjs());
    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState([]);

    const header = [
        { name: 'Si No', label: '#', active: true },
        { name: 'Date', label: 'Date', active: true },
        { name: 'Day', label: 'Day', active: true },
        { name: 'type', label: 'Type', active: true },
        { name: 'time', label: 'Time', active: true },
    ];

    const token = localStorage.getItem('accessToken');

    useEffect(() => {
        const fetchstudentAttendance = async () => {
            try {
                setLoading(true);
                const formattedDate = selectDate.format('YYYY-MM-DD');
                const attendanceResponse = await axios.get(
                    `${process.env.REACT_APP_API}/api/course/student-punch-records/`,
                    {
                        params: { date: formattedDate, student_id: id },
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                // Set student details
                const studentData = attendanceResponse.data.punch_records[0] || {};
                setStudent({
                    student_name: studentData.student_name || "N/A",
                    course: studentData.selected_course || "N/A",
                    Phone: studentData.contact_number || "N/A"
                });

                // Transform punch records
                const transformedData = attendanceResponse.data.punch_records.flatMap((item, index) =>
                    item.punch_time.map((time, punchIndex) => ({
                        'Si No': index * item.punch_time.length + punchIndex + 1,
                        Date: item.punch_date || "N/A",
                        Day: item.day || "N/A",
                        type: item.punch_direction[punchIndex] === 0 ? 'In' : 'Out',
                        time: time,
                    }))
                );

                setProduct(transformedData);
            } catch (error) {
                console.log("Something went wrong", error);
            } finally {
                setLoading(false);
            }
        };

        fetchstudentAttendance();
    }, [id, token, selectDate]);

    return (
        <div className="AttendanceContainer w-100 h-100 px-3 px-lg-4 pt-3">
            <h3 className="pt-2">Single Day Data</h3>

            <div className="empData">
                <p className="text-secondary m-0">
                    Name: <span className="text-black">{student.student_name || "N/A"}</span>
                </p>
                <p className="m-0 text-secondary">
                    Course: <span className="text-black">{student.course || "N/A"}</span>
                </p>
                <p className="m-0 text-secondary">
                    Phone: <span className="text-black">{student.Phone || "N/A"}</span>
                </p>
            </div>

            <div className="d-flex w-100 gap-3 align-items-center justify-content-end">
                <div className='mb-3'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Select a Date"
                            value={selectDate}
                            className="MuidatePicker1"
                            onChange={(newValue) => setSelectDate(newValue)}
                            renderInput={(params) => <input {...params} className="form-control" />}
                        />
                    </LocalizationProvider>
                </div>
            </div>

            {loading ? (
                <Spinner />
            ) : product.length > 0 ? (
                <Table header={header} product={product} loading={loading} onRowClick={() => { }} />
            ) : (
                <div className="d-flex justify-content-center align-items-end position-relative" style={{ height: '50vh' }}>
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            backgroundImage: 'url(/assets/file.png)',
                            backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            opacity: 0.3,
                        }}
                    ></div>
                    <p className="m-0 fw-light fs-5 position-relative">No Attendance or Leave Data!</p>
                </div>
            )}
        </div>
    );
}